import Compliance from './Compliance'

export default Compliance
